
import { defineComponent } from 'vue'
import useEmojis from '@/composables/emojis/emojis'

export default defineComponent({
  name: 'EmojiPicker',
  emits: ['insert-emoji'],
  setup() {
    const { emojiList } = useEmojis()

    return {
      emojiList,
    }
  },
})
